// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 524) return "static/css/524.4dbedb1b6.chunk.css";
	// return url for filenames based on template
	return undefined;
};